import { afterTransition } from './../utility/transition'

let x = 0
const count = () => ++x;


export function menu({ menu, background, className = 'is-open' }) {

	let isOpen = false
	const html = document.documentElement

	menu.setAttribute('id', menu.id || 'menu' + count())
	background.setAttribute('role', 'presentation')
	background.addEventListener('click', close)
	window.addEventListener('keydown', onKeydown)
	ariaClose(menu)

	function ariaOpen(el) {
		el.removeAttribute('aria-hidden')
		el.setAttribute('tabindex', '0')
	}

	function ariaClose(el) {
		el.setAttribute('tabindex', '-1')
		el.setAttribute('aria-hidden', true)
	}

	function open(button) {
		isOpen = true
		menu.style.display = 'block'
		background.style.display = 'block'
		menu.getBoundingClientRect()
		html.style.overflow = 'hidden'
		html.classList.add('menu-open')
		menu.dispatchEvent(new CustomEvent('menu', { 
			bubbles: false,
			detail: isOpen,
    	}))
		afterTransition(menu, el => {
			ariaOpen(el)
	    	el.focus()
		})
		menu.classList.add(className)
		background.classList.add(className)
	}

	function close(button) {
		isOpen = false
		html.classList.remove('menu-open')
		menu.dispatchEvent(new CustomEvent('menu', { 
			bubbles: false,
			detail: isOpen,
    	}))
		afterTransition(menu, el => {
			ariaClose(el)
			el.style.display = 'none'
			html.style.overflow = ''
	    	if (button && button instanceof Element) button.focus()
		})
		afterTransition(background, el => {
			el.style.display = 'none'
		})
		menu.classList.remove(className)
		background.classList.remove(className)
	}

	function toggle(button) {
		isOpen ? close(button) : open(button)
	}

	function onKeydown(event) {
		const escKey = (event.key === 'Escape' || event.keyCode === 27)
		if (isOpen && escKey) toggle()
	}

	return {
		open, 
		close, 
		toggle, 
		el: menu,
	}
}


export function menuToggle({ menu, toggle }) {
	toggle.setAttribute('aria-haspopup', true)
	toggle.setAttribute('aria-expanded', false)
	toggle.setAttribute('aria-controls', menu.el.id)
	menu.el.addEventListener('menu', changeHandler)
	toggle.addEventListener('click', event => menu.toggle(event.currentTarget))
	function changeHandler(event) {
		toggle.setAttribute('aria-expanded', event.detail)
	}
}